import { render, staticRenderFns } from "./upload-invoice.vue?vue&type=template&id=bb9de56e&scoped=true&"
import script from "./upload-invoice.vue?vue&type=script&lang=js&"
export * from "./upload-invoice.vue?vue&type=script&lang=js&"
import style0 from "./upload-invoice.vue?vue&type=style&index=0&id=bb9de56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9de56e",
  null
  
)

export default component.exports